/* Auto-Replace launch tracking (spec v3.1). No UTMs.
 * - Remembers the FIRST ?ar_src= value seen in this browser session (sessionStorage "ar_src").
 * - Publishes Shopify Customer Events (Shopify.analytics.publish) for a custom pixel:
 *   ar_entry_click {src}, plus ar_card_view / ar_card_select {interval, src} / ar_atc {interval, src} from ar-widget.js.
 *   No health, condition or customer data in any payload (no page URLs, product titles or handles).
 * Loaded from layout/theme.liquid when Theme settings > Auto-Replace > Launch tracking is on.
 */
(() => {
  if (window.ARTrack) return;
  const KEY = 'ar_src';
  const ALLOWED = /^[a-z0-9_]{1,32}$/;
  const read = (url) => { try { return new URL(url, location.href).searchParams.get(KEY); } catch (e) { return null; } };
  const store = (v) => { try { if (v && ALLOWED.test(v) && !sessionStorage.getItem(KEY)) sessionStorage.setItem(KEY, v); } catch (e) {} };
  store(read(location.href));

  const queue = [];
  const flush = () => {
    const a = window.Shopify && window.Shopify.analytics;
    if (!a || typeof a.publish !== 'function') return false;
    while (queue.length) { const [n, d] = queue.shift(); try { a.publish(n, d); } catch (e) {} }
    return true;
  };
  let tries = 0;
  const wait = () => { if (!flush() && tries++ < 40) setTimeout(wait, 250); };

  window.ARTrack = {
    src() { try { return sessionStorage.getItem(KEY) || ''; } catch (e) { return ''; } },
    publish(name, data) {
      queue.push([name, Object.assign({ src: this.src() || 'none' }, data || {})]);
      if (!flush()) { tries = 0; wait(); }
    }
  };

  // Entry clicks: any internal link carrying ?ar_src=
  document.addEventListener('click', (e) => {
    const a = e.target.closest && e.target.closest('a[href*="ar_src="]');
    if (!a) return;
    const v = read(a.href);
    if (!v || !ALLOWED.test(v)) return;
    store(v);
    window.ARTrack.publish('ar_entry_click', { src: v });
  }, true);
})();
